/**
 * 云服务类别 产品图表页 图表Item
 *
 * @format
 */

import React, { useRef, useImperativeHandle, forwardRef } from 'react'
import ReactEcharts, { EChartsInstance, EChartsReactProps } from 'echarts-for-react'
import { echartDefaultOption } from './constants'
export interface EchartReactHandle {
  getEchartsInstance: () => EChartsInstance
}
const EchartReact = forwardRef<EchartReactHandle, EChartsReactProps>((props, ref) => {
  const chartRef = useRef(null)
  useImperativeHandle(ref, () => ({
    getEchartsInstance: () => {
      return chartRef.current?.getEchartsInstance()
    }
  }))

  const { style, option, ...rest } = props

  return (
    <ReactEcharts
      ref={chartRef}
      {...rest}
      style={{ width: '100%', height: '100%', ...style }}
      option={{
        ...echartDefaultOption,
        ...option
      }}
    />
  )
})
export default React.memo(EchartReact)
